/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Workflow_HelpInputs */

const en_ticket_section_workflow_help = /** @type {(inputs: Ticket_Section_Workflow_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap the next step you're starting or finishing. Buttons enable as the ticket progresses.`)
};

const ja_ticket_section_workflow_help = /** @type {(inputs: Ticket_Section_Workflow_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始または終了する次のステップをタップしてください。チケットの進行に応じてボタンが有効になります。`)
};

const fr_ticket_section_workflow_help = /** @type {(inputs: Ticket_Section_Workflow_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touchez la prochaine étape que vous démarrez ou terminez. Les boutons s'activent au fil du ticket.`)
};

const de_ticket_section_workflow_help = /** @type {(inputs: Ticket_Section_Workflow_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippen Sie auf den nächsten Schritt, den Sie starten oder beenden. Buttons werden im Verlauf des Tickets aktiv.`)
};

/**
* | output |
* | --- |
* | "Tap the next step you're starting or finishing. Buttons enable as the ticket progresses." |
*
* @param {Ticket_Section_Workflow_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_workflow_help = /** @type {((inputs?: Ticket_Section_Workflow_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Workflow_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_workflow_help(inputs)
	if (locale === "ja") return ja_ticket_section_workflow_help(inputs)
	if (locale === "fr") return fr_ticket_section_workflow_help(inputs)
	return de_ticket_section_workflow_help(inputs)
});